'use client'
import {
  isChakraTheme,
  requiredChakraThemeKeys
} from "./chunk-MGJ324P3.mjs";
import {
  foundations
} from "./chunk-5FMCT5RQ.mjs";
import "./chunk-RXCYWA6Q.mjs";
import "./chunk-5QZEG2IM.mjs";
import "./chunk-PE5G6LAZ.mjs";
import "./chunk-ZCARTYDH.mjs";
import "./chunk-OFZWI3IK.mjs";
import "./chunk-AMMMMB27.mjs";
import "./chunk-A3OO4VZD.mjs";
import "./chunk-EXHLCVSK.mjs";
import {
  components
} from "./chunk-BVEAU2MF.mjs";
import "./chunk-QHVXS45H.mjs";
import "./chunk-XRIBTYHG.mjs";
import "./chunk-FI633VWD.mjs";
import "./chunk-T6EHV47V.mjs";
import "./chunk-VM3745AK.mjs";
import "./chunk-TN6RO673.mjs";
import "./chunk-J54NBX2J.mjs";
import "./chunk-BA7PF5LB.mjs";
import "./chunk-BJIKSU3K.mjs";
import "./chunk-ILLVD2I4.mjs";
import "./chunk-T6E7UBRI.mjs";
import "./chunk-URZN3QPP.mjs";
import "./chunk-PUPKOASV.mjs";
import "./chunk-HOBQJOCR.mjs";
import "./chunk-66QM3UU6.mjs";
import "./chunk-73PQYQVW.mjs";
import "./chunk-NTN663XT.mjs";
import "./chunk-RRJIKBCH.mjs";
import "./chunk-3XV5CZGX.mjs";
import "./chunk-JIVTZ35T.mjs";
import "./chunk-VEZNC4IQ.mjs";
import "./chunk-VW4MZLZF.mjs";
import "./chunk-HFED6QOE.mjs";
import "./chunk-F25MPA3T.mjs";
import "./chunk-5FAATIOO.mjs";
import "./chunk-VJU277AG.mjs";
import "./chunk-OQ4UESHD.mjs";
import "./chunk-66WVPDP6.mjs";
import "./chunk-2RLCRBJQ.mjs";
import "./chunk-SZS2B4EE.mjs";
import "./chunk-FIZIJHUN.mjs";
import "./chunk-CHG7JP5U.mjs";
import "./chunk-MMPN6JKT.mjs";
import "./chunk-N5CTW2M4.mjs";
import "./chunk-Y7UXPTSV.mjs";
import "./chunk-FC2RT2FC.mjs";
import "./chunk-I7MXUFNA.mjs";
import "./chunk-R5JELUQ3.mjs";
import "./chunk-6PVQMBW4.mjs";
import {
  semanticTokens
} from "./chunk-SKQLGI36.mjs";
import {
  styles
} from "./chunk-RID7N3YQ.mjs";
import "./chunk-ZSQCKRFE.mjs";
import "./chunk-MTSOOEOV.mjs";
import "./chunk-CJYJRQES.mjs";
import "./chunk-EYWUA2TC.mjs";
import "./chunk-QH74K4BV.mjs";
import "./chunk-NIUVG5KM.mjs";
import "./chunk-RQ25AHBB.mjs";
import "./chunk-4FUZMKSO.mjs";

// src/index.ts
var direction = "ltr";
var config = {
  useSystemColorMode: false,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
};
var theme = {
  semanticTokens,
  direction,
  ...foundations,
  components,
  styles,
  config
};
var src_default = theme;
var baseTheme = {
  semanticTokens,
  direction,
  components: {},
  ...foundations,
  styles,
  config
};
export {
  baseTheme,
  src_default as default,
  isChakraTheme,
  requiredChakraThemeKeys,
  theme
};
//# sourceMappingURL=index.mjs.map